import React from 'react'
import { Grid, GridProps } from '@mui/material'

interface ResponsiveGridProps extends Omit<GridProps, 'container' | 'item'> {
  children: React.ReactNode
  spacing?: number
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

interface ResponsiveGridItemProps extends GridProps {
  children: React.ReactNode
  xs?: number | 'auto' | true
  sm?: number | 'auto' | true
  md?: number | 'auto' | true
  lg?: number | 'auto' | true
  xl?: number | 'auto' | true
}

export const ResponsiveGrid: React.FC<ResponsiveGridProps> = ({
  children,
  spacing = 3,
  maxWidth,
  ...props
}) => {
  return (
    <Grid
      container
      spacing={spacing}
      sx={{
        maxWidth: maxWidth ? `${maxWidth}.breakpoint` : undefined,
        mx: maxWidth ? 'auto' : undefined,
        ...props.sx,
      }}
      {...props}
    >
      {children}
    </Grid>
  )
}

export const ResponsiveGridItem: React.FC<ResponsiveGridItemProps> = ({
  children,
  xs = 12,
  sm,
  md,
  lg,
  xl,
  ...props
}) => {
  return (
    <Grid
      item
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      xl={xl}
      {...props}
    >
      {children}
    </Grid>
  )
}

// Predefined responsive breakpoints for common layouts
export const ResponsiveBreakpoints = {
  // Full width on mobile, half on tablet, third on desktop
  thirds: { xs: 12, sm: 6, md: 4 },
  // Full width on mobile, half on tablet and up
  halves: { xs: 12, sm: 6 },
  // Full width on mobile, quarter on tablet and up
  quarters: { xs: 12, sm: 6, md: 6, lg: 3 }, // Better mobile/tablet layout
  // Two-thirds and one-third layout
  twoThirds: { xs: 12, md: 8 },
  oneThird: { xs: 12, md: 4 },
  // Sidebar layout
  sidebar: { xs: 12, md: 3 },
  main: { xs: 12, md: 9 },
}